export default "__VITE_ASSET__rUzj8NKL__"